import { Component, ElementRef, Inject, Input, LOCALE_ID, NgZone, ViewChild } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { environment } from 'src/environments/environment';
import { BasePageComponent } from '../../base-page/base-page.component';
import { MissionDetailsService } from 'src/app/services/missions/mission-details.service';
import { MISSIONTYPE, Mission, MissionAchievement } from 'src/app/services/missions/missions.models';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { timer } from 'rxjs';
import { MissionService } from 'src/app/services/missions/mission.service';
import { MissionInfoBoxComponent } from '../mission-info-box/mission-info-box.component';

interface TournamentEndCountDown {
  days: number,
  hours: number,
  minutes: number,
  seconds: number
}

@Component({
  selector: 'app-mission-overview',
  templateUrl: './mission-overview.component.html',
  styleUrls: ['./mission-overview.component.scss']
})
export class MissionOverviewComponent extends MissionInfoBoxComponent {

  public MISSION_LOCALIZED_ACHEVEMENTS = {
    stake: $localize`:@mission@schievementStake:play stake`,
    win_n_times: $localize`:@mission@schievementWinNTimes:win number of times`,
    win_multiplier: $localize`:@mission@schievementStake:max win multiplier`,
    win_value: $localize`:@mission@schievementMaxWin:max win`,
    rounds: $localize`:@mission@schievementRounds:play number of runds`,
  }
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    protected missionDetailsService: MissionDetailsService,
    protected loginStatusService: LoginStatusService,
    protected licenceService: LicenceService,
    public missionService: MissionService,
    protected _ngZone: NgZone,
  ) {
    super(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      licenceService
    )
  }

  protected _mission: Mission;
  public countDown: TournamentEndCountDown;
  tournamentEndDateLocal: Date;
  tournamentStartDateLocal: Date;
  // achievements: MissionAchievement[];
  minBetCurrency: string;
  minBet: number;
  isUpcommingRefreshed: boolean = true;
  now: Date;
  game: string;
  @Input() ref: string;
  @Input() missions: Mission;
  @ViewChild('tournamentstartdate') tournamentStartDateElement: ElementRef;


  @Input() set missionsTime(tournamentInput: Mission) {
    this.tournamentStartDateLocal = new Date(tournamentInput.startDate);
    this._mission = tournamentInput;
    this.tournamentStartDateLocal = new Date(tournamentInput.startDate);
    this.tournamentEndDateLocal = new Date(tournamentInput.endDate);
    this.isUpcommingRefreshed = false;

    if (tournamentInput.games.length > 1) {
      let index = 0;
      this._ngZone.runOutsideAngular(() => {
        timer(0, 2000).pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
          this.game = tournamentInput.games[index].name;
          index = (index + 1) % tournamentInput.games.length;
        })
      });

    }
    else {
      this.game = tournamentInput.games[0].name
    }

    if (tournamentInput.missionType === MISSIONTYPE.ACTIVE) {
      this.countDown = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      }
      this._ngZone.runOutsideAngular(() => {
        const source = timer(0, 1000).pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
          this.now = new Date(Date.now());
          const diff = Math.max(0, Math.floor(Math.floor((new Date(this._mission.endDate).getTime() - new Date().getTime()) / 1000)));

          let seconds = diff;
          let minutes = Math.floor(seconds / 60);
          let hours = Math.floor(minutes / 60);
          let days = Math.floor(hours / 24);

          hours = hours - (days * 24);
          minutes = minutes - (days * 24 * 60) - (hours * 60);
          seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

          this.countDown.days = days;
          this.countDown.hours = hours;
          this.countDown.minutes = minutes;
          this.countDown.seconds = seconds;
          if (this.tournamentStartDateElement) {
            if (this.countDown.days > 0) {
              this.tournamentStartDateElement.nativeElement.innerHTML = `${this.countDown.days}d ${this.countDown.hours}h ${this.countDown.minutes}m`;
            }
            else {
              this.tournamentStartDateElement.nativeElement.innerHTML = `${this.countDown.hours}h ${this.countDown.minutes}m ${this.countDown.seconds}s`;

            }
          }
        })
      });
    }
    else if (tournamentInput.missionType === MISSIONTYPE.UPCOMMING) {
      this._ngZone.runOutsideAngular(() => {
        const source = timer(0, 5000).pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
          this.now = new Date(Date.now());
          this.now.setSeconds(this.now.getSeconds() - 30)
          if (this.now >= this.tournamentStartDateLocal && !this.isUpcommingRefreshed) {
            this.isUpcommingRefreshed = true;
            this.missionService.forceUpdateStore();
          }
        })
      });
    }
  }


  math = Math;
  myPosition: number;
  // achievements: MissionAchievement[];
  currency: string;
  // minBetCurrency: string;
  // minBet: number;
  endDates: String;
  nickname: string;
  // tournamentStartDateLocal: Date;
  // now: Date;
  isLogged: boolean;
  isShowMore: boolean = false;
  isCompleted: boolean;
  INITIAL_RANK_LENGTH: number = 20;
  SHOWMORE_RANK_LENGTH: number = 200;
  rankSize = this.INITIAL_RANK_LENGTH;


  getDetails() {
    this.loginStatusService.getLoginStatus().pipe(takeUntil(this.unsubscribe)).subscribe(status => {
      if (status.isLogged === LoggedStatus.logged) {
        this.isLogged = true;
        this.currency = status.currency;
        const minBetCurrencies = this.mission.minBetCurrencies;
        if (minBetCurrencies && minBetCurrencies[this.currency.toLowerCase()]) {
          this.minBet = minBetCurrencies[this.currency.toLowerCase()];
          this.minBetCurrency = status.currency;
        }
        else {
          this.minBet = this.mission.minBet;
          this.minBetCurrency = environment.baseCurrency;
        }
        if(this._mission && this._mission.ref){
          this.missionDetailsService.getMissionAchievements(this._mission, this._mission.cmsId, this.minBetCurrency, true).pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
            this.achievements = resp.achievements;
            this.isCompleted = resp.isCompleted;
          })
        }
      }
      else {
        this.isLogged = false;
        this.minBet = this.mission.minBet;
        this.minBetCurrency = environment.baseCurrency;
      }

    })
    this.numberPrizes = 1;

    this.endDate = `${new Date(this.mission.endDate).toLocaleDateString()} ${new Date(this.mission.endDate).toLocaleTimeString()}`;
  }
  ngOnInit(): void {
    this.getDetails();
    ({ finalProgress: this.spinerValue, achievementsComplited: this.achievementsComplited } = this.missionDetailsService.calculateProgress(this._mission.missionsAchievements));
    console.log('minBetC', this.mission.prize)
  }

  myPoints: number;
  numberPrizes: number = 25;

}
